import React from "react"

export const USER_ROLE = {
  compliance: 'Compliance',
  hr: 'Recursos Humanos',
  admin: 'Administrador',
  adminReadOnly: 'Apenas Leitura',
  accessManager: 'Gestor de Acessos',
  recruitersApi: 'API de Recrutadores',
}

/** Possíveis status de um item da aplicação. Valores usados pela API. */
export const ITEM_STATUS = {
  processing: 'PROCESSING',
  processed: 'PROCESSED',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT = {
  approved: 'APPROVED',
  reproved: 'REPROVED',
  waitingReview: 'WAITING_REVIEW',
}

/** Possíveis status de uma aplicação. Valores usados pela API. */
export const APPLICATION_STATUS = {
  created: 'CREATED',
  bgcProcessing: 'BGC_PROCESSING',
  waitingForReview: 'WAITING_FOR_REVIEW',
  bgcProcessedMissingCreditAnalysis: 'BGC_PROCESSED_MISSING_CREDIT_ANALYSIS',
  finished: 'FINISHED',
}

/** Possíveis status de uma aplicação. Valores mostrados ao usuário. */
export const APPLICATION_STATUS_DESCRIPTION = {
  created: 'Aplicação iniciada',
  bgcProcessing: 'Processando BGC',
  bgcProcessedMissingCreditAnalysis: 'Concluído sem a Análise de Crédito',
  waitingForReview: 'Aguardando revisão',
  error: 'Erro',
  finished: 'Concluído',
}

export const CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION = {
  created: 'Aplicação iniciada',
  bgcProcessing: 'Processando BGC',
  bgcProcessedMissingCreditAnalysis: 'Concluído sem a Análise de Crédito',
  waitingForReview: 'Aguardando revisão',
  error: 'Erro',
  approved: 'Aprovado',
  reproved: 'Reprovado',
}

export const APPLICATION_TIMELINE_STATUS_STEPS = {
  created: 'Aplicação iniciada',
  bgcProcessing: 'Processando BGC',
  waitingForReview: 'Aguardando revisão',
  finished: 'Concluído',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT_DESCRIPTION = {
  approved: 'Aprovado(a)',
  reproved: 'Reprovado(a)',
  waitingForReview: 'Revisão necessária',
}

export const WAITING_CLARIFICATION_VALUES = {
  ALL: undefined,
  SHOW: true,
  HIDE: false,
}

export const SUSPENDED_ANALYSIS_MESSAGE = (
  <p>
    Uma revisão pendente é SUSPENSA se o candidato:
    <br></br>
    1. é marcado como &quot;Rejected&quot; ou &quot;Hired&quot; na Greenhouse sem que tenha passado por todo o fluxo; ou 
    <br></br>
    2. foi REPROVADO em outra análise, logo nenhuma decisão é necessária sobre esta.
  </p>
)
